import IndexManager from "../index-manager";
import debuggingProps from "./index.debug";
import { handlePreview } from "./index.preview";
import { debounce } from "lodash";

(async function() {

  /* ***************** */
  /*     Settings      */
  /* ***************** */

  const manager = new IndexManager('t', {
    // Exclusive Params
    't_theme': 'default',
    't_font': 'default',
    't_source': 'active-goal',
    't_sincedate': '00:00:0000',
    't_price': 0,
    't_customtitle': 'Target traktiran minggu ini',
    't_showlink': 'false',
    't_show_nominal': 'true',
    't_show_target_nominal': 'true',
    't_show_progress': 'true',
    't_txtshadow': 'false',

    // Colors: default
    't_1_clr1': '#be1e2d',
    't_1_clr2': '#fff',
    't_1_clr3': '#ffa500',

    // Colors: retro
    't_2_clr1': '#fff',
    't_2_clr2': '#be1e2d',
    't_2_clr3': '#313131',
    't_2_clr4': '#262522',

    //colors transitional
    't_3_clr1': '#ffffff',
    't_3_clr2': '#444444',
    't_3_clr3': '#ffffff',
    't_3_clr4': '#0000001a',
    't_3_clr5': '#be1e2d',
    't_3_clr6': '#444444',
    /* custom */
    't_4_html': '', 
    't_4_css': '', 
  });

  /* ***************** */
  /*  Widget Behavior  */
  /* ***************** */
 
  class TrWidget {

    data = {};
    setting = {};
    theme = '';

    pageUrl = '';

    async setup(themeSetting, themeProps) {
      this.setting = themeSetting;
      this.theme = themeProps[this.setting['t_theme']];
      this.theme.setup(this.setting);
      this.applyStyle();

      if(this.setting['t_theme'] == 'custom') {
        await this.theme.setupCustomSetting(manager)
      }
    }

    /* Styling */

    applyStyle() {
      // Set Styles
      const styles = this.theme.styles();
      for (let i = 0; i < styles.length; i++) {
        const style = styles[i];
        h.setThemeVar(style.var, this.setting[style.key] || style.default);
      }
      // Set Fonts
      const reqFont = this.setting['t_font'] || 'default';
      h.setThemeVar(
        this.theme.font().var,
        reqFont === 'default' ? this.theme.font().default : "'" + reqFont + "'"
      );

      //for default theme, set shadow effect option
      if(this.setting['t_theme'] == 'default' && h.isTrue(this.setting['t_txtshadow'])) {
        let shadows = this.theme.styleShadowOption();
        for (let i = 0; i < shadows.length; i++) {
          const shadow = shadows[i];
          h.setThemeVar(shadow.var, shadow.default);
        }
      }

    }

    /* Animation Logic */

    async reset(data) {
      this.data = data;
    }

    async updateData(data) {
      if (!this.theme) return;
      if (!this.setting) {
        console.debug('Applied setting not found');
        return;
      }
      if(data == null) return;
      if(Object.keys(data).length === 0) return;

      const prevData = this.data;
      await this.reset(data);
      this.theme.render(data);

      if (prevData.targetProgress < 100 && data.targetProgress >= 100) {
        this.theme.onGoalReached();
      }
    }

  }

  /* ***************** */
  /*   Widget Manager  */
  /* ***************** */

  IndexManager.prototype.reload = async function(data) {
    this.widget.updateData(data);
  }

  IndexManager.prototype.reloadHandler = debounce(() => {
    manager.loadData(/* true */);
  }, 5000, { 'maxWait': 10000 });

  IndexManager.prototype.updateReceived = function(newTargetReceived) {
    let tempData = h.cloneProp(this.widget.data);

    const targetPrice = parseInt(tempData.targetPrice);
    const newTargetProgress = (String)(newTargetReceived / targetPrice * 100);

    this.widget.updateData(Object.assign(tempData, {
      targetProgress: newTargetProgress,
      targetReceived: newTargetReceived,
      targetValue: `${h.formatPrice(newTargetReceived)} / ${h.formatPrice(targetPrice)}`,
    }));
  }

  /* ***************** */
  /*      API Call     */
  /* ***************** */

  IndexManager.prototype.loadData = async function(shouldForceRefresh = false) {
    let self = this;
    superagent
      .get(this.apiUrl(`stream/${this.key}/target-data`))
      .query({
        source: this.get('t_source'),
        sincedate: this.get('t_sincedate'),
        price: this.get('t_price'),
        customtitle: this.get('t_customtitle'),
        showtarget: this.get('t_show_target_nominal'),
        ...(shouldForceRefresh ? { force_refresh: true } : {}),
      })
      .accept('application/json')
      .end(function (err, res) {
        try {
          self.reload(res.body)
        } catch (err) {
          // console.log(err);
          console.error('API call failed:', err.message);
          return null; // Return something to continue running
        }
    });
  }

  /* ***************** */
  /*     Websocket     */
  /* ***************** */

  function setupListener() {
    manager.addListenerOn('new-tip', function(data) {
      manager.reloadHandler()
    });
    manager.addListenerOn('new-tip-simulation', function(data) {
      manager.reloadHandler()
    });

    // Failover if webssockets has an issues
    if (!h.prop(manager, 'widget.setting.debug')) {
      setInterval(function() {
        manager.reloadHandler();
      }, 5 * 60 * 1000);
    }
  }

  /* ***************** */
  /*       Init        */
  /* ***************** */

  setupListener();

  await manager.init({
    widget: new TrWidget(),
    debug: debuggingProps,
    preview: handlePreview
  });
})();
